"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translate_1 = require("components/translate");
const HotmartPlayerActiveBadge = ({ t }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "_d-flex _align-items-center _ml-2", children: (0, jsx_runtime_1.jsx)("hot-tag", { class: "hot-tag--green", children: t('player_active_info_modal.title') }) }));
};
exports.default = (0, translate_1.translate)()(HotmartPlayerActiveBadge);
